// Auto-advance carousels on mobile
(function () {
  function initCarousel(carousel, itemSelector) {
    var cards = carousel.querySelectorAll(itemSelector);
    if (cards.length < 2) return;
    var current = 0;
    setInterval(function () {
      current = (current + 1) % cards.length;
      carousel.scrollTo({ left: cards[current].offsetLeft, behavior: 'smooth' });
    }, 3000);
  }

  function initAllCarousels() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.price-card').forEach(function (el) {
      initCarousel(el, '.single-card');
    });
    var investItem = document.querySelector('#invest .item');
    if (investItem) initCarousel(investItem, '.card');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
})();

fetch("https://goldapi.deuslab.com/?function=grain_value&key=pepe", { method: "GET" })
  .then(res => res.json())
  .then(res => {
    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    const d = (res && res.data) || {};
    if (d.au) {
      set("chartDate",    d.au.date);
      set("chartSymbol",  d.au.currency_symbol);
      set("chartValue",   ` ${d.au.value}/gr`);
    }
    if (d.ag) {
      set("chartDate2",   d.ag.date);
      set("chartSymbol2", d.ag.currency_symbol);
      set("chartValue2",  ` ${d.ag.value}/gr`);
    }
    if (d.pd) {
      set("chartDate3",   d.pd.date);
      set("chartSymbol3", d.pd.currency_symbol);
      set("chartValue3",  ` ${d.pd.value}/gr`);
    }
    if (d.pt) {
      set("chartDate4",   d.pt.date);
      set("chartSymbol4", d.pt.currency_symbol);
      set("chartValue4",  ` ${d.pt.value}/gr`);
    }
  })
  .catch(() => {});